import React from 'react'
import styles from './header.jcss'
import Icon from 'blocks.simple/icon/icon'
import { color } from 'theme/tokens/color'
import translate from 'core/translate'

interface IHeader {
    onUpDirectory: () => void
    onUpdateDirectory: () => void
    onRootDirectory: () => void
    setPath: (path: string) => void
    path: string
    onCreateFolder: () => void
}

export const Header = ({
    onRootDirectory,
    onUpDirectory,
    onUpdateDirectory,
    setPath,
    path,
    onCreateFolder,
}: IHeader) => {
    return (
        <div className={styles.header}>
            <div className={styles.buttons}>
                <Icon
                    type={'createFolder'}
                    color={color.iconWhiteHigh}
                    size={24}
                    style={{ marginRight: 4 }}
                    tooltip={{ title: translate('createFolder') }}
                    onClick={onCreateFolder}
                />
                <Icon
                    type={'directoryUp'}
                    color={color.iconWhiteHigh}
                    size={24}
                    style={{ marginRight: 4 }}
                    tooltip={{ title: translate('back') }}
                    onClick={onUpDirectory}
                />
                <Icon
                    type={'directoryRefresh'}
                    color={color.iconWhiteHigh}
                    size={24}
                    style={{ marginRight: 4 }}
                    tooltip={{ title: translate('update') }}
                    onClick={onUpdateDirectory}
                />
                <Icon
                    type={'home'}
                    color={color.iconWhiteHigh}
                    size={24}
                    tooltip={{ title: translate('onRootDirectory') }}
                    onClick={onRootDirectory}
                />
            </div>
            <div className={styles.search}>
                <form
                    onSubmit={(e: any) => {
                        e.preventDefault()

                        onUpdateDirectory()
                    }}
                >
                    <input className={styles.searchInput} value={path} onInput={(e: any) => setPath(e.target.value)} />
                </form>
            </div>
        </div>
    )
}
